/** Utilitários de CNPJ: normalização, dígito verificador e formatação. */
/** Só os 14 dígitos, sem máscara. Retorna `null` se não houver 14 dígitos. */
export function normalizeCnpj(raw) {
    const digits = (raw ?? "").replace(/\D/g, "");
    return digits.length === 14 ? digits : null;
}
/** `12.345.678/0001-95` a partir de 14 dígitos (ou devolve a entrada crua). */
export function formatCnpj(raw) {
    const d = normalizeCnpj(raw);
    if (!d)
        return raw ?? "";
    return `${d.slice(0, 2)}.${d.slice(2, 5)}.${d.slice(5, 8)}/${d.slice(8, 12)}-${d.slice(12)}`;
}
function checkDigit(base) {
    // Pesos da Receita: começam em 2, vão até 9 e reciclam.
    let sum = 0;
    let weight = 2;
    for (let i = base.length - 1; i >= 0; i--) {
        sum += Number(base[i]) * weight;
        weight = weight === 9 ? 2 : weight + 1;
    }
    const mod = sum % 11;
    return mod < 2 ? 0 : 11 - mod;
}
/** Valida os dois dígitos verificadores. Rejeita sequências repetidas (`00000000000000`). */
export function isValidCnpj(raw) {
    const d = normalizeCnpj(raw);
    if (!d)
        return false;
    if (/^(\d)\1{13}$/.test(d))
        return false;
    const dv1 = checkDigit(d.slice(0, 12));
    if (dv1 !== Number(d[12]))
        return false;
    const dv2 = checkDigit(d.slice(0, 13));
    return dv2 === Number(d[13]);
}
//# sourceMappingURL=cnpj.js.map